import i18n from "i18next";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";
import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { uploadFile } from "src/utils/fileUploading.ts";

export interface ImportFromVertexIndButtonProps {
	submit: (fileHandle: FrontendUploadFileHandle) => Promise<unknown>;
}

export const ImportFromVertexIndButton = ({ submit }: ImportFromVertexIndButtonProps) => {
	const showInputDialog = useInputDialog();

	return (
		<AsyncMenuButton
			label={i18n.t("import_from_vertex")}
			icon={faFileImport}
			onClick={async () => {
				const file = await showInputDialog({
					title: i18n.t("select_vertex_file"),
					type: "singleFile",
					defaultValue: null,
					required: true,
					fieldProps: {
						file: {
							accept: "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						},
					},
				});
				if (file === undefined || file == null) return;

				const fileHandle = await uploadFile(file);
				await submit(fileHandle);
			}}
		/>
	);
};

